import AddDestinationWithModals from '@anm/components/stream/destination_management/AddDestinationWithModals';
import { FC } from 'react';

import config from '../../../../config';
import routes from '../../../../routes';

import LiveButtons from './LiveButtons';
import { AddDestinationWrapper } from './Wrapper';
import { RightButtonsProps } from './types'

const { urls } = config();
const { Router } = routes;

const RightButtons: FC<RightButtonsProps> = ({ currentTab, onOpenNewStreamModal }) => (
  <>
    {currentTab === 'Destinations' ? (
      <AddDestinationWrapper>
        <AddDestinationWithModals
          waveUrl={urls.wave}
          waveApiUrl={urls.apiWave}
          onRedirect={link => Router.pushRoute(link)}
        />
      </AddDestinationWrapper>
    ) : (
      <LiveButtons onOpenNewStreamModal={onOpenNewStreamModal} />
    )}
  </>
);

export default RightButtons;
